
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.125 2H2.875C1.839 2 1 2.863 1 3.929V18.07C1 19.137 1.84 20 2.875 20h16.25C20.161 20 21 19.137 21 18.071V3.93C21 2.863 20.16 2 19.125 2zm-9.093 15.333H3.581v-10h6.451v10zm8.387 0h-6.451v-10h6.451v10z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_menu_mesa_de_trabalho.svg